import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./pageButtons.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent, registerListener } from 'util/pubsub';
class PageButtons extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    this.variant = "border-filled";
    this.currentPageNumber = void 0;
    this.maxPages = void 0;
    this.pdfDoc = void 0;
    this.showPDFTitle = false;
    this.hidePageNavigation = false;
    this.hideSearch = false;
    this.showThumbnailsButton = false;
    this.pdfTitle = "PDF";
    // This is needed by the pubsub code to assure that events are only sent between components on the same page. We
    // need to come up with some attribute(s) that we can use to mark the components as belonging to a certain page/application.
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
  }
  connectedCallback() {
    let self = this;
    // If the hide attributes were set in the markup, they will be strings; the <template if:...> that references the hide attributes requires booleans to be accurate.
    if (typeof this.hidePageNavigation === 'string' || this.hidePageNavigation instanceof String) {
      this.hidePageNavigation = this.hidePageNavigation === 'true';
    }
    if (typeof this.hideSearch === 'string' || this.hideSearch instanceof String) {
      this.hideSearch = this.hideSearch === 'true';
    }
    registerListener(eventTypes.SHOW_PDF_PAGE, self.handleShowPdf, self);
    registerListener(eventTypes.REFRESH_TOOLBAR_DATA, self.handleToolbarRefresh, self);
    this.showThumbnailsButton = true; //ORV240305 undo change to hide showThumbnailsButton as false and off will have same behaviour
  }
  handleShowPdf(evt) {
    console.log("received show pdf event : ", evt);
    if (evt.detail.source != "toolbar" && evt.detail.pageNumber) {
      this.template.querySelector('.pageNumberInput').value = evt.detail.pageNumber;
      this.currentPageNumber = evt.detail.pageNumber;
    }
  }
  handleToolbarRefresh(evt) {
    let options = {};
    this.setPdfPageDetails(options);
  }
  handleToggleThumbnails(evt) {
    let event = new CustomEvent(eventTypes.TOGGLE_THUMBNAILS, {
      detail: true
    });
    fireEvent(this.pageRef, eventTypes.TOGGLE_THUMBNAILS, event);
  }
  setPdfPageDetails(options) {
    console.log("setPdfPageDetails start");
    this.currentPageNumber = options.currentPageNumber ? options.currentPageNumber : 1;
    this.template.querySelector(".pageNumberInput").value = options.currentPageNumber;
    this.maxPages = options.maxPages;
    this.pdfDoc = options.pdfDoc;
    if (this.pdfDoc) {
      //set the pdftitle variable
      if (__g_title) {
        this.pdfTitle = __g_title;
      } else {
        this.pdfTitle = 'PDF';
      }
    }
    console.log("setPdfPageDetails end");
  }
  renderedCallback() {
    this.template.querySelector(".pageNumberInput").value = this.currentPageNumber;
  }
  guardPageNumberInfo() {
    if (!this.currentPageNumber) {
      if (typeof __g_selectedPages === 'string' || __g_selectedPages instanceof String) {
        let selectedPages = __g_selectedPages.split(',');
        try {
          this.currentPageNumber = selectedPages[selectedPages.length - 1] ? parseInt(selectedPages[selectedPages.length - 1]) : 1;
        } catch (err) {
          console.warn("Exception converting selected page value to number: selected pages = " + __g_selectedPages + " trying to convert value: " + selectedPages[selectedPages.length - 1]);
        }
      } else if (Number.isFinite(__g_selectedPages)) {
        this.currentPageNumber = __g_selectedPages;
      } else {
        this.currentPageNumber = 1;
      }
    }
    // In mobile, this can be zero, don't allow that.
    if (0 === this.currentPageNumber) {
      this.currentPageNumber = 1;
    }
    if (!this.maxPages) {
      try {
        this.maxPages = __g_pdfDoc___._pdfInfo.numPages;
      } catch (err) {
        console.warn("Exception setting maxPages from __g_pdfDoc___: ", __g_pdfDoc___);
      }
    }
  }
  displayFirstPage(e) {
    e.preventDefault();
    this.guardPageNumberInfo();
    console.log("display first page invoked");
    let self = this;
    if (self.currentPageNumber > 1) {
      //let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {source: "toolbar", detail: 1, bubbles: true, cancelable: true});
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "toolbar",
          pageNumber: 1
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(this.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      self.currentPageNumber = 1;
      this.template.querySelector('.pageNumberInput').value = self.currentPageNumber;
    }
  }
  displayPreviousPage(e) {
    e.preventDefault();
    this.guardPageNumberInfo();
    console.log("display prev page invoked");
    let self = this;
    if (self.currentPageNumber > 1) {
      //let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {source: "toolbar", detail: self.currentPageNumber-1, bubbles: true, cancelable: true});
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "toolbar",
          pageNumber: self.currentPageNumber - 1
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(this.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      self.currentPageNumber -= 1;
      this.template.querySelector('.pageNumberInput').value = self.currentPageNumber;
    }
  }
  pageNumberChange(e) {
    e.preventDefault();
    console.log("display selected page invoked");
    let self = this;
    if (e.target.value && !isNaN(e.target.value) && e.target.value > 0 && e.target.value <= self.maxPages) {
      //let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {source: "toolbar", detail: parseInt(e.target.value), bubbles: true, cancelable: true});
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "toolbar",
          pageNumber: parseInt(e.target.value)
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(this.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      self.currentPageNumber = parseInt(e.target.value);
    } else if (e.target.value && !isNaN(e.target.value) && (e.target.value < 0 || e.target.value > self.maxPages) || e.target.value && isNaN(e.target.value)) {
      alert("Page Number not valid");
    }
  }
  displayNextPage(e) {
    e.preventDefault();
    this.guardPageNumberInfo();
    console.log("display next page invoked");
    let self = this;
    if (self.currentPageNumber < self.maxPages) {
      //let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {source: "toolbar", detail: self.currentPageNumber+1, bubbles: true, cancelable: true});
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "toolbar",
          pageNumber: self.currentPageNumber + 1
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(this.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      self.currentPageNumber += 1;
      this.template.querySelector('.pageNumberInput').value = self.currentPageNumber;
    }
  }
  displayLastPage(e) {
    e.preventDefault();
    this.guardPageNumberInfo();
    console.log("display last page invoked");
    let self = this;
    if (self.currentPageNumber < self.maxPages) {
      //let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {source: "toolbar", detail: self.maxPages, bubbles: true, cancelable: true});
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "toolbar",
          pageNumber: self.maxPages
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(this.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      self.currentPageNumber = self.maxPages;
      this.template.querySelector('.pageNumberInput').value = self.currentPageNumber;
    }
  }
  searchPdf(e) {
    e.preventDefault();
    console.log("searchPdf invoked");
    let searchText = this.template.querySelector('.search-pdf-text').value.trim();
    __g_zPDF_formHelper__.search(searchText);
  }
}
_registerDecorators(PageButtons, {
  publicProps: {
    variant: {
      config: 0
    },
    currentPageNumber: {
      config: 0
    },
    maxPages: {
      config: 0
    },
    pdfDoc: {
      config: 0
    },
    showPDFTitle: {
      config: 0
    },
    hidePageNavigation: {
      config: 0
    },
    hideSearch: {
      config: 0
    }
  },
  publicMethods: ["setPdfPageDetails"],
  fields: ["showThumbnailsButton", "pdfTitle", "pageRef"]
});
export default _registerComponent(PageButtons, {
  tmpl: _tmpl
});